module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center justify-lg-content-between"
  }, [_c('div', {
    staticClass: "col-lg-6 d-flex flex-column"
  }, [_c('div', {
    staticClass: "logos order-md-2"
  }, [_vm._t("logos")], 2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-5"
  }, [_vm._t("form"), _vm._v(" "), _c('div', [_c('h3', {
    staticStyle: {
      "font-weight": "700",
      "font-size": "30px !important"
    }
  }, [_vm._v("See How Fast We Can Get You Funded")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../assets/imgs/American_Credit_Business_Loans.png"),
      "alt": "American Credit Business loans the Difference You can Trust"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    staticClass: "cta",
    attrs: {
      "to": "/get-start?step=1",
      "tag": "button"
    }
  }, [_vm._v("Get a quote")])], 1)])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed4e2254"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/industries/FormSection.vue
// module id = 2034
// module chunks = 5